﻿import classNames from "classnames";
import { useOutputDocuments } from "providers";
import { useTranslations } from "providers";
import React from "react";

export const ParticipantsWarning: React.FC = () => {
  const i18n = useTranslations();
  const { showParticipantsWarnings } = useOutputDocuments();

  if (!showParticipantsWarnings) return null;

  return (
    <span
      className={classNames("global-tooltip-trigger", "warning-icon")}
      title={i18n.Meeting_UpdateParticipants_Warning_Tooltip}
    >
      <i className="ms-Icon ms-Icon--IncidentTriangle" />
    </span>
  );
};
